import {
    BaseFeatureArgs,
    FixedFilterGenerator,
    SkipOrArgs,
} from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useCollections, UseCollectionsArgs } from './useCollections';

export interface UseCollectionAssetIdsArgs extends BaseFeatureArgs {
    collectionId: string;
}

const collectionAssetIdsFilterGenerator: FixedFilterGenerator<
    UseCollectionAssetIdsArgs
> = (args) => {
    return [`parentId:${args.collectionId}`];
};

export const useCollectionAssetIds = (
    args: SkipOrArgs<UseCollectionAssetIdsArgs>,
) => {
    const { itemCount, isLoading } = useCollections(
        { pageSize: 0, pageIndex: 0 },
        args,
    );

    const queryArgs: SkipOrArgs<UseCollectionsArgs> = useMemo(() => {
        if (args === skipToken || isLoading || !itemCount) return skipToken;

        return {
            ...args,
            overrideFilterGenerator: collectionAssetIdsFilterGenerator,
        } as UseCollectionsArgs;
    }, [args, itemCount, isLoading]);

    return useCollections({}, queryArgs, {
        paramsOverride: { pageSize: itemCount, pageIndex: 0 },
    });
};
